<template>
  <div class="checked-tag">
    <img class="img" src="@/assets/travelAgency/ic_pass.png" v-if="isPass" />
    <img class="img" src="@/assets/travelAgency/ic_nopass.png" v-else />
    <span :class="isPass ? 'txt' : 'txt orangecolor'">{{title}}</span>
  </div>
</template>
<script>
    export default {
        components: {},
        props: {

            title: {
                type: String,
                default: ''
            },
            isPass: {
                type: Boolean,
                default: true
            }

        },
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {

        },
        mounted () {}
    }
</script>
<style scoped lang="less">
  .checked-tag{
    display: flex;
    align-items: center;
    height: 18px;
    overflow: hidden;
    margin-right: 8px;
    .img{
      display: inline-block;
      width:12px;
      // height: 12px;
      margin-right: 3px;
      margin-top: -2px;
    }
    .txt{
      margin-left: 2px;
      font-size:12px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(54,179,116,1);
    }
    .orangecolor{
      color: #FF8C19;

    }
  }
</style>
